// extracted by mini-css-extract-plugin
export default {"Input":"Input_Input__XR286","Label":"Input_Label__PGneN","InputElement":"Input_InputElement__+Fu4i","Invalid":"Input_Invalid__TDAFc"};